import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";

import Mandala from "../../../../../public/pricing/heading/mandala.png";

import styles from "./styles.module.scss";

const Heading: FC = () => {
  const router = useRouter();

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <div className={styles.leftPanel}>
        <Label color="primary" className={styles.title} variant="h">
          Your home, managed by experts
        </Label>
        <Label color="primary" className={styles.subtitle} variant="s">
          When you join Humming Homes, you get a team that takes care of every
          aspect of your home. You don’t have to worry about your home to-do
          list anymore. You’ll get to focus on the things that really matter,
          and build memories that last.
        </Label>
        <div className={styles.membershipContainer}>
          <Label color="white" className={styles.pricing} variant="s">
            $250
          </Label>
          <Label color="primary" className={styles.membershipLabel} variant="h">
            Your membership comes with cost-savings and perks!
          </Label>
        </div>
        <Button
          onClick={() => router.push("/start")}
          variant="accent"
          className={styles.joinNow}
        >
          Join now
        </Button>
      </div>
      <Media at={["desktop"]} className={styles.rightPanel}>
        <div className={styles.image}>
          <Image alt="" width={650} height={650} layout="fixed" src={Mandala} />
        </div>
      </Media>
      <Media at={["responsive"]} className={styles.rightPanel}>
        <div className={styles.image}>
          <Image alt="" layout="responsive" src={Mandala} />
        </div>
      </Media>
    </Content>
  );
};

export default Heading;
